import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata,
} from 'molbio/bulk-assembly/tables/BulkAssemblyConstructsStructuredTableAdapter';
import {
  OverflowMenuActionFunction,
  TableActionFunctionParameters,
} from 'notebook/structured-tables/StructuredTableConstants';
import {BLUE_LIGHT, BLUE_POWDER} from 'ui-library/Colors';
import {OverflowMenuOption} from 'ui-library/menus/OverflowMenu';

export const toggleFragmentDetailsActionFunction: OverflowMenuActionFunction<
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata
> = {
  getOverflowMenuItem: (
    params: TableActionFunctionParameters<
      BulkAssemblyConstructsStructuredTableMetadata,
      BulkAssemblyConstructsStructuredTableRowMetadata
    >
  ): OverflowMenuOption => {
    const {
      structuredTable: {metadata},
    } = params;
    return {
      icon: 'check',
      iconClassName: metadata.showFragmentDetails ? css(styles.selected) : undefined,
      contentClassName: metadata.showFragmentDetails ? css(styles.selected) : undefined,
      contents: <span>Show fragment details</span>,
      onSelect: () => {
        metadata.onToggleFragmentDetails(!metadata.showFragmentDetails);
      },
    };
  },
};

const styles = StyleSheet.create({
  selected: {
    color: BLUE_LIGHT,
    backgroundColor: BLUE_POWDER,
  },
});
